import { render, staticRenderFns } from "./SupportedBanks.vue?vue&type=template&id=539b5d86&scoped=true&"
import script from "./SupportedBanks.vue?vue&type=script&lang=ts&"
export * from "./SupportedBanks.vue?vue&type=script&lang=ts&"
import style0 from "./SupportedBanks.vue?vue&type=style&index=0&id=539b5d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b5d86",
  null
  
)

export default component.exports